
  <h4 class="text-center sunrise-header"> {{student.fullname}} </h4>
  <h5 class="text-center sunrise-header"> Study Material for {{subscription.name}}  </h5>
<div id="accordionSubjThemes" class="max-width" *ngIf="quizarea_syllabus.topics.length>0">
  <div *ngFor="let topic of quizarea_syllabus.topics; index as myCount;" class="card" >

    <div class="card-header" id="headingTheme{{topic.id}}">
      <h5 class="mb-0">
        <a class="btn btn-link" data-bs-toggle="collapse" href="#collapseTheme{{topic.id}}" aria-expanded="true" aria-controls="collapseOne">
          <span [appMath]="topic.name"></span>
        </a>
      </h5>
    </div>

    <div id="collapseTheme{{topic.id}}" class="collapse {{myCount==0?'show':''}}" aria-labelledby="headingTheme{{topic.id}}" data-parent="#accordionSubjThemes">
      <div class="card-body">
       <app-study-subtopic [topic]="topic" [subscription]="subscription" [studentUserId]="studentUserId"></app-study-subtopic>
      </div>
    </div>

</div>
</div>
<app-spinner *ngIf="loading"></app-spinner>
<div class="text-center mt-4">
  <a [routerLink]="['/student/show',student.server_user_id]" class='btn btn-primary me-2'> Ok</a>
</div>
